// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pmreportspg-inline-1 {
  text-align: center;
  padding: 40px;
}

.pmreportspg-inline-2 {
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #991b1b;
}

.pmreportspg-inline-3 {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.pmreportspg-inline-5 {
  padding: 0;
  overflow-x: auto;
}

.pmreportspg-inline-6 {
  text-align: center;
  padding: 30px;
  color: #94a3b8;
}

.pmreportspg-inline-7 {
  font-family: monospace;
  font-size: 11px;
}

.pmreportspg-inline-8 {
  font-weight: 600;
}

.pmreportspg-inline-9 {
  display: flex;
  gap: 6px;
}

.pmreportspg-inline-10 {
  max-width: 180px;
}

.pmreportspg-inline-11 {
  margin-bottom: 10px;
  font-size: 12px;
  color: #475569;
}

.pmreportspg-inline-12 {
  margin-bottom: 8px;
  padding: 10px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.pmreportspg-inline-13 {
  font-weight: 600;
  font-size: 12px;
}

.pmreportspg-inline-14 {
  font-size: 12px;
}

.pmreportspg-inline-15 {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 10px;
}

.pmreportspg-inline-16 {
  background: #d97706;
}

.pmreportspg-inline-17 {
  margin-top: 16px;
}

.pmreportspg-inline-18 {
  font-weight: 700;
  font-size: 12px;
  margin-bottom: 8px;
}

.pmreportspg-inline-19 {
  color: #94a3b8;
  font-size: 12px;
}

.pmreportspg-inline-20 {
  border-bottom: 1px solid #f1f5f9;
  padding: 6px 0;
}

.pmreportspg-inline-21 {
  font-size: 11px;
  font-weight: 600;
}

.pmreportspg-inline-22 {
  font-size: 11px;
  color: #64748b;
}

.pmreportspg-inline-23 {
  font-size: 10px;
  color: #94a3b8;
}

.pmreportspg-inline-24 {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.pmreportspg-inline-25 {
  position: fixed;
  inset: 0;
  background: rgba(2,6,23,.45);
  display: grid;
  place-items: center;
  z-index: 3000;
}

.pmreportspg-inline-26 {
  width: min(1000px, 94vw);
  height: min(88vh, 760px);
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}

.pmreportspg-inline-27 {
  padding: 10px 12px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pmreportspg-inline-28 {
  font-weight: 700;
}

.pmreportspg-inline-29 {
  width: 100%;
  height: 100%;
  border: 0;
}

.pmreportspg-dyn-1 {
  font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/PM/PMReportsPg.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".pmreportspg-inline-1 {\n  text-align: center;\n  padding: 40px;\n}\n\n.pmreportspg-inline-2 {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  color: #991b1b;\n}\n\n.pmreportspg-inline-3 {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 12px;\n  flex-wrap: wrap;\n}\n\n.pmreportspg-inline-5 {\n  padding: 0;\n  overflow-x: auto;\n}\n\n.pmreportspg-inline-6 {\n  text-align: center;\n  padding: 30px;\n  color: #94a3b8;\n}\n\n.pmreportspg-inline-7 {\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.pmreportspg-inline-8 {\n  font-weight: 600;\n}\n\n.pmreportspg-inline-9 {\n  display: flex;\n  gap: 6px;\n}\n\n.pmreportspg-inline-10 {\n  max-width: 180px;\n}\n\n.pmreportspg-inline-11 {\n  margin-bottom: 10px;\n  font-size: 12px;\n  color: #475569;\n}\n\n.pmreportspg-inline-12 {\n  margin-bottom: 8px;\n  padding: 10px;\n  border-radius: 8px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n}\n\n.pmreportspg-inline-13 {\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.pmreportspg-inline-14 {\n  font-size: 12px;\n}\n\n.pmreportspg-inline-15 {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  margin-top: 10px;\n}\n\n.pmreportspg-inline-16 {\n  background: #d97706;\n}\n\n.pmreportspg-inline-17 {\n  margin-top: 16px;\n}\n\n.pmreportspg-inline-18 {\n  font-weight: 700;\n  font-size: 12px;\n  margin-bottom: 8px;\n}\n\n.pmreportspg-inline-19 {\n  color: #94a3b8;\n  font-size: 12px;\n}\n\n.pmreportspg-inline-20 {\n  border-bottom: 1px solid #f1f5f9;\n  padding: 6px 0;\n}\n\n.pmreportspg-inline-21 {\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.pmreportspg-inline-22 {\n  font-size: 11px;\n  color: #64748b;\n}\n\n.pmreportspg-inline-23 {\n  font-size: 10px;\n  color: #94a3b8;\n}\n\n.pmreportspg-inline-24 {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 10px;\n}\n\n.pmreportspg-inline-25 {\n  position: fixed;\n  inset: 0;\n  background: rgba(2,6,23,.45);\n  display: grid;\n  place-items: center;\n  z-index: 3000;\n}\n\n.pmreportspg-inline-26 {\n  width: min(1000px, 94vw);\n  height: min(88vh, 760px);\n  background: #fff;\n  border-radius: 12px;\n  overflow: hidden;\n  border: 1px solid #e2e8f0;\n}\n\n.pmreportspg-inline-27 {\n  padding: 10px 12px;\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.pmreportspg-inline-28 {\n  font-weight: 700;\n}\n\n.pmreportspg-inline-29 {\n  width: 100%;\n  height: 100%;\n  border: 0;\n}\n\n.pmreportspg-dyn-1 {\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
